
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ticket-sales-rules",
      function () {
        return require("private-next-pages/ticket-sales-rules.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ticket-sales-rules"])
      });
    }
  